import axios, { AxiosInstance, AxiosError } from 'axios';
import { ApiError } from '../types/auth.types';

class ApiService {
  private api: AxiosInstance;
  private baseURL: string;

  constructor() {
    this.baseURL = import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1';

    this.api = axios.create({
      baseURL: this.baseURL,
      headers: {
        'Content-Type': 'application/json',
      },
    });

    this.api.interceptors.request.use(
      (config) => {
        const token = localStorage.getItem('accessToken');
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    this.api.interceptors.response.use(
      (response) => response,
      (error: AxiosError<ApiError>) => {
        if (error.response?.status === 401) {
          // Only redirect on 401 if we're NOT on an auth page
          // Auth pages (sign-in, sign-up, etc.) expect 401 errors for invalid credentials
          const currentPath = window.location.pathname;
          const isAuthPage = ['/signin', '/signup', '/reset-password', '/reset-password-confirmation', '/verify-email'].includes(currentPath);

          if (!isAuthPage) {
            localStorage.removeItem('accessToken');
            localStorage.removeItem('refreshToken');
            window.location.href = '/signin';
          }
        }
        return Promise.reject(error);
      }
    );
  }

  get client() {
    return this.api;
  }
}

export default new ApiService();